import React from 'react';

import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import styled from 'styled-components';

import theme from 'constants/theme';

export const PlayIcon = ({
  className,
  fillColor = theme.palette.primary.main,
  backgroundColor = theme.palette.primary.main,
  rotate,
  ...props
}) => (
  <StyledPlayCircleFilledIcon
    $fillColor={fillColor}
    $backgroundColor={backgroundColor}
    className={className}
    rotate={rotate}
    {...props}
  />
);

const StyledPlayCircleFilledIcon = styled(PlayArrowIcon)`
  border-radius: 50%;
  background: ${(props) => `${props.$backgroundColor}1f`};
  fill: ${(props) => props.$fillColor};
  padding: 5px;
  ${({ rotate }) =>
    rotate &&
    `
    transform: rotate(90deg);
    `};
`;
